import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { T } from '../../i18n/copy';
import { clinicPath } from '../../i18n/paths';
import Reveal from '../Reveal';

export default function FinalCta({ lang }) {
  const t = T.finalCta;
  return (
    <section data-header-theme="midnight" data-testid="final-cta-section" className="bg-midnight text-bone">
      <div className="editorial-margins py-20 md:py-24">
        <Reveal>
          <div className="flex items-center gap-3">
            <span className="inline-block h-2 w-2 bg-vermilion" aria-hidden="true" />
            <span className="eyebrow text-bone/60">{t.eyebrow[lang]}</span>
          </div>
        </Reveal>
        <Reveal delay={0.08} className="mt-8">
          <h2 className="max-w-3xl font-tight font-semibold text-[clamp(2.4rem,5.4vw,5rem)] leading-[1.02] tracking-[-0.02em]" data-testid="final-cta-headline">
            {t.headline[lang]}
          </h2>
        </Reveal>
        <Reveal delay={0.14} className="mt-8 max-w-lg">
          <p className="text-base leading-relaxed text-bone/70">
            {t.bodyLead[lang]}{' '}
            <span className="font-serif italic text-bone">
              {t.bodyWords[lang].map((w, i) => (
                <span key={w}>
                  {w}
                  {i < t.bodyWords[lang].length - 1 && <span className="text-vermilion"> / </span>}
                </span>
              ))}
            </span>{' '}
            {t.bodyTail[lang]}
          </p>
        </Reveal>
        <Reveal delay={0.2} className="mt-12 flex flex-col gap-5 sm:flex-row sm:items-center">
          <Link
            to={clinicPath(lang)}
            data-testid="final-cta-button"
            className="group inline-flex items-center justify-center gap-3 bg-vermilion px-7 py-4 text-[13px] font-medium tracking-[0.06em] text-bone transition-colors duration-300 hover:bg-[#A8402C]"
          >
            {t.cta[lang]}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
          </Link>
          <a
            href={`mailto:${t.email}`}
            data-testid="final-cta-email"
            className="inline-flex items-center justify-center border-b border-bone/30 pb-1 text-[14px] text-bone/80 transition-colors duration-300 hover:border-vermilion hover:text-bone"
          >
            {t.email}
          </a>
        </Reveal>
      </div>
    </section>
  );
}
